/*

This is where you define your action creators. 
All action creators must be functions that return an object 
with at least the type property. 
We do not define any async logic in this file.

*/

import types from './types';

const requestCheckEmail = () => ({
  type: types.REQUEST_CHECK_EMAIL
});

const resetCheckEmail = () => ({
  type: types.RESET_CHECK_EMAIL
});

const requestCheckCode = () => ({
  type: types.REQUEST_CHECK_CODE
});

const receiveCheckEmail = (error, text) => ({
  type: types.RECEIVE_CHECK_EMAIL,
  error,
  text
});

const receiveCheckCode = (error, text, link, completed) => ({
  type: types.RECEIVE_CHECK_CODE,
  error,
  text,
  link,
  completed
});

export {
  requestCheckEmail,
  resetCheckEmail,
  receiveCheckEmail,
  requestCheckCode,
  receiveCheckCode
};
